import { CaptchaDTO } from './../models/captchaDTO.model';
import { LocalUser } from '../core/config/localUser';
import { LoginParticipante } from '../models/login-participante.model';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Credencias } from '../models/credencias.model';
import { Observable, throwError } from 'rxjs';
import { StorageService } from './storage.service';
import { catchError } from 'rxjs/operators';
import { Eleitor } from '../models/eleitor.model';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  jwtHelperService: JwtHelperService = new JwtHelperService();

  loginParticipante: LoginParticipante;

  constructor(
    private http: HttpClient,
    private storage: StorageService
  ) { }


  public authenticateLogin(creds: Credencias) {
    return this.http.post(`${environment.url_api}/login`,
      creds,
      {
        observe: 'response',
        responseType: 'text'
      })
  }

  public successfullLogin(authorizationValue: string) {
    let tok = authorizationValue;
    let user: LocalUser = {
      token: tok,
      login: this.jwtHelperService.decodeToken(tok).sub,
      expitedToken: this.jwtHelperService.isTokenExpired(tok)
    };
    this.storage.setLocalUser(user);
  }

  public logout() {
    this.storage.setLocalUser(null);
    sessionStorage.clear();
  }

  public getParticipantePorLogin(): Observable<Eleitor> {
    //return this.http.get<LoginParticipante>(`${environment.url_api}/participantes/usuario`)
    return this.http.get<Eleitor>(`${environment.url_api}/eleitor/self`)
  }


  public updateSenha(loginParticipante: LoginParticipante): Observable<LoginParticipante> {
    return this.http.put<LoginParticipante>(`${environment.url_api}/participantes`, loginParticipante, environment.httpOptions);
  }

  public captchaCheck(captcha: CaptchaDTO): Observable<any> { 
    return this.http.post(`${environment.url_api}/captchas/request`, captcha, environment.httpOptions);
  }


  /* handleError -  */
  protected handleError(error: any): Observable<any> {
    console.log("ERRO NA REQUISIÇÃO => ", error);
    return throwError(error);
  }


}
